import { useMutation } from '@apollo/client';
import Bugsnag from '@bugsnag/js';
import { loader } from 'graphql.macro';
import { useFlags } from 'launchdarkly-react-client-sdk';

const summarizeMeetingMutation = loader('./summarizeMeeting.graphql');
const analyzeInspectionMutation = loader('./analyzeInspection.graphql');

export const useAIMutations = () => {
  const { disableAi } = useFlags();
  const [summarizeMeeting] = useMutation(summarizeMeetingMutation);
  const [analyzeInspection] = useMutation(analyzeInspectionMutation);

  const summarizeAudio = async ({ inspectionId, onComplete = () => {} }) => {
    if (disableAi) return;
    try {
      await summarizeMeeting({
        variables: { inspectionId },
      });
      onComplete();
    } catch (e) {
      console.error(e);
      Bugsnag.notify(e);
    }
  };

  const secondSightAnalysis = async ({ id, onComplete = () => {} }) => {
    if (disableAi) return;
    try {
      await analyzeInspection({ variables: { id } });
      onComplete();
    } catch (e) {
      console.error(e);
      Bugsnag.notify(e);
    }
  };

  return {
    summarizeAudio,
    secondSightAnalysis,
  };
};
